import store from '@/store/index';

var webSocket = null;
let receiveProgress = ( actionId, progressCallback) =>{
  var authToken = store.getters.getAuthToken
  //var endpoint = 'ws://35.79.155.34:8080/endpoint/' + actionId + '/' + authToken
  var endpoint = 'wss://koromaga.jp/endpoint/' + actionId + '/' + authToken
  //var endpoint = 'ws://localhost:8080/endpoint/' + actionId + '/' + authToken
  console.log(endpoint)
  webSocket = new WebSocket(endpoint);

  webSocket.onopen = function() {
    console.log("onopen");
  };

  webSocket.onmessage = function(message) {
    console.log(message.data); 
    progressCallback(message.data)
  };
  
  webSocket.onclose = function() {
    console.log("onclose");
    progressCallback("Close@")
    webSocket = null;
  };
  
  webSocket.onerror = function( event ){
     console.log("onerror");
     console.log(event);
  }
}

let closeSocket = ()=>{
  if( webSocket != null ){
    webSocket.close();
    webSocket = null;
  }
}


export{ 
  receiveProgress,
  closeSocket
}